import { init, browserTracingIntegration, replayIntegration } from '@sentry/vue'
import { extraErrorDataIntegration } from '@sentry/integrations'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {
    public: { sentry },
  } = useRuntimeConfig()

  if (!sentry.dsn) {
    return
  }

  // If in development mode, don't initialize
  if (process.env.NODE_ENV === 'development') {
    return
  }

  init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    enabled: process.env.NODE_ENV !== 'development',
    integrations: [
      browserTracingIntegration({ router }),
      replayIntegration({
        networkDetailAllowUrls: [window.location.origin],
      }),
      extraErrorDataIntegration(),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, // Change in prod

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/partners\.thrivestate\.(io|dev|app)/],

    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
})
